import React, { Component } from 'react'
import { Table, Button, Input, Icon, Tooltip } from 'antd';
import Highlighter from 'react-highlight-words';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { observer } from 'mobx-react';
import CategoriesStore from '../../stores/CategoriesStore';
import MyBetStage from '../layoutComponents/MyBetStage';
const ethMultiplier = 1000000000000000000;
const data = [{
    key: '1',
    id: "0x1",
    category: 'Football',
    event: 'Los Angeles Rams v New England Patriots',
    date: new Date().toLocaleDateString(),
    status: 'Cancelled',
}, {
    key: '2',
    id: "0x2",
    category: 'Hockey',
    event: 'Toronto Maple Leafs v Arizona Coyotes',
    date: new Date(1550639363000).toLocaleDateString(),
    status: 'Settled - Win'
},
{
    key: '3',
    id: "0x3",
    category: "Hockey",
    event: 'Toronto Maple Leafs v Colorado Avalanche',
    date: new Date(1550725763000).toLocaleDateString(),
    status: 'Settled - Loss',
}];

@observer(["CategoriesStore", "eventStore", "TeamStore", "WagerStore", "UserStore"])
class MyBetTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filteredInfo: null,
            sortedInfo: null,
            searchText: "", tableData: [],
            checked: false,
            contentRendered: false
        };
        this.getEventData = this.getEventData.bind(this);
        this.renderContent = this.renderContent.bind(this);
    }

    renderContent() {
        let tableData = [];
        let self = this;
        self.props.data.forEach((wager) => {
            let eventData = self.getEventData(wager.wager.eventId);
            tableData.push({
                key: wager.wager.bytes32Id,
                id: <span className="eth-address" style={{ cursor: 'pointer' }}>
                    <CopyToClipboard text={wager.wager.bytes32Id}>
                        <Tooltip placement="bottom" title="Click to copy">
                            <span style={{ backgroundColor: "rgba(255,255,255,0.2)", borderRadius: 4, fontSize: "12pt" }}>{wager.wager.bytes32Id.slice(0, 5)}...</span>
                        </Tooltip>
                    </CopyToClipboard>
                </span>,
                category: eventData.category,
                event: eventData.title,
                date: eventData.date,
                status: <MyBetStage status={wager.status} wager={wager.wager} makerTaker={wager.maker ? "maker" : "taker"} event={eventData.event} propEvent={false} />,
                yourStake: (wager.maker ? wager.wager.value : ((wager.wager.odds > 99) ?
                    wager.wager.value / (wager.wager.odds / 100)
                    :
                    wager.wager.value * Math.floor(100 / wager.wager.odds))),
                totalValue: (wager.wager.value + ((wager.wager.odds > 99) ?
                    wager.wager.value / (wager.wager.odds / 100)
                    :
                    wager.wager.value * Math.floor(100 / wager.wager.odds))) / ethMultiplier

            });
        });
        tableData.sort((a, b) => {
            return b.date - a.date;
        });

        let newTableData = tableData.map((origObj) => {
            return {
                key: origObj.key,
                id: origObj.id,
                category: origObj.category,
                event: origObj.event,
                date: new Date(origObj.date * 1000).toLocaleDateString(),
                status: origObj.status,
                totalValue: <span style={{ color: "#1890ff" }}>{origObj.totalValue.toFixed(4)}</span>,
                yourStake: (origObj.yourStake / ethMultiplier).toFixed(4),
                // opponentsStake: (origObj.opponentsStake / ethMultiplier).toFixed(4)
            }
        });
        self.setState({ tableData: newTableData, checked: true, contentRendered: true });
    }

    getEventData(eventId) {
        const { CategoriesStore, eventStore, TeamStore } = this.props;
        let thisEvent = eventStore.events.get(eventId);
        let teamOne = TeamStore.teams.get(thisEvent.teams[0]);
        let teamTwo = TeamStore.teams.get(thisEvent.teams[1]);
        let eventTitle = (thisEvent.isPropEvent ? thisEvent.propTitle : teamOne.name + " V " + teamTwo.name);
        let eventCategory = CategoriesStore.categories.get(thisEvent.categoryId).title;
        let eventDate = thisEvent.startTime + thisEvent.duration;
        return ({ category: eventCategory, date: eventDate, title: eventTitle, event: thisEvent });
    }

    handleChange = (pagination, filters, sorter) => {
        console.log('Various parameters', pagination, filters, sorter);
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
        });
    }

    clearFilters = () => {
        this.setState({ filteredInfo: null });
    }

    clearAll = () => {
        this.setState({
            filteredInfo: null,
            sortedInfo: null,
        });
    }

    setAgeSort = () => {
        this.setState({
            sortedInfo: {
                order: 'descend',
                columnKey: 'date',
            },
        });
    }

    getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
            setSelectedKeys, selectedKeys, confirm, clearFilters,
        }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => { this.searchInput = node; }}
                        placeholder={`Search ${dataIndex}`}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm)}
                        icon="search"
                        size="small"
                        style={{ width: 90, marginRight: 8 }}
                    >
                        Search
            </Button>
                    <Button
                        onClick={() => this.handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reset
            </Button>
                </div>
            ),
        filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: (text) => (
            <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[this.state.searchText]}
                autoEscape
                textToHighlight={text.toString()}
            />
        ),
    })

    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({ searchText: selectedKeys[0] });
    }

    handleReset = (clearFilters) => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    render() {
        const { WagerStore, eventStore, TeamStore, CategoriesStore, UserStore } = this.props;
        if (!this.state.contentRendered && this.props.dataGot
        ) {
            let self = this;
            setTimeout(() => {
                self.renderContent();
            }, 120);
        }
        let { sortedInfo, filteredInfo } = this.state;
        sortedInfo = sortedInfo || {};
        filteredInfo = filteredInfo || {};
        const columns = [
            {
                title: "ID",
                dataIndex: 'id',
                key: 'id'
            },
            {
                title: 'Event',
                dataIndex: 'event',
                key: 'event',

                ...this.getColumnSearchProps('event'),
            },
            {
                title: 'Category',
                dataIndex: 'category',
                key: 'category',
                filters: [
                    { text: 'Football', value: 'Football' },
                    { text: 'Hockey', value: 'hockey' },
                    { text: 'Basketball', value: 'basketball' },
                    { text: 'MMA', value: 'MMA' },
                    { text: 'Baseball', value: 'Baseball' },
                    { text: 'Soccer', value: 'Soccer' },
                    { text: 'E-Sports', value: 'e-sports' }
                ],
                filteredValue: filteredInfo.category || null,
                onFilter: (value, record) => record.category.includes(value),

            }, {
                title: 'Date',
                dataIndex: 'date',
                key: 'date',

            },
            {
                title: 'Your Stake',
                dataIndex: 'yourStake',
                key: 'yourStake',

            },
            // {
            //     title: "Opponent's Stake",
            //     dataIndex: 'opponentsStake',
            //     key: 'opponentsStake',

            // },
            {
                title: 'Total Value',
                dataIndex: 'totalValue',
                // sorter: (a, b) => Number(a.totalValue) - Number(b.totalValue),
                // sortDirections: ['descend', 'ascend'],

            }, {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
                // filters: [

                //     { text: 'Settled', value: 'settled' },
                //     { text: "Cancelled", value: 'cancelled' },
                //     { text: "Win", value: "WIN" },
                //     { text: "Loss", value: "LOSS" }
                // ],
                // filteredValue: filteredInfo.status || null,
                // onFilter: (value, record) => record.status.innerHTML.includes(value),

            }];

        return (
            <div >
                {this.state.tableData.length === 0 && !this.state.checked ?
                    <Icon style={{ textAlign: "center", fontSize: '46px', color: '#08c' }} type="loading" />
                    : this.state.tableData.length === 0 && this.state.checked ? <span style={{ color: "rgba(255,255,255,0.7)" }}>NO BETS FOUND</span> :
                        <Table pagination={false} className="custom-table" rowClassName="custom-table-row" columns={columns} dataSource={this.state.tableData} onChange={this.handleChange} />}
            </div>
        );
    }
}
export default MyBetTable;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/MyBetTable.js